import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

import { adhikariService } from "../../../../app/adhikari/service/api/adhikari.service";
import { SessionService } from "../../../../app/common/services/session.service";
import { ComplaintService } from "../../complaint-service/api/complaint.service";

@Component({
  selector: "app-adhikari-reassign",
  templateUrl: "./adhikari-reassign.component.html",
  styleUrls: ["./adhikari-reassign.component.scss"],
})
export class AdhikariReassignComponent implements OnInit {
  selectedAdhikari: any;
  adhikariData: any;
  complainObj: any;
  _rowData: any;
  userInfo: any;
  sendMessage: any;
  cancelFlag: boolean;

  @Output() dataUpdated = new EventEmitter<any>();

  @Input()
  set rowData(value) {
    this._rowData = value;
    if (this._rowData && this._rowData.adhikari) {
      this.selectedAdhikari = this._rowData.adhikari;
    }
    if (this._rowData) {
      this.complainObj = this._rowData;
    }
  }
  get rowData() {
    return this._rowData;
  }
  constructor(
    private adhikariService: adhikariService,
    private complaintService: ComplaintService,
    private ss: SessionService
  ) {}

  getAdhikariList() {
    this.adhikariService.getAdhikariData({}).subscribe((data) => {
      this.adhikariData = data;
    });
  }

  removeAdhikari(adhikariForRemove: any) {
    this.selectedAdhikari = this.selectedAdhikari.filter(function (
      e,
      index,
      arr
    ) {
      return e.id != adhikariForRemove.id;
    },
    this);
  }

  submitData() {
    this.complainObj.adhikari = this.selectedAdhikari;
    this.complaintService.createComplaintData(this.complainObj).subscribe(
      (res: any) => {
        res.isEdit = false;
        this.rowData = res;
        this._rowData = res;
        this.dataUpdated.emit(res);
      },
      (err) => {},
      () => {}
    );
  }
  cancel() {
    this.dataUpdated.emit({});
  }
  ngOnInit() {
    this.getAdhikariList();
  }
}
